export default __webpack_public_path__ + "static/media/conjunto-logos-footer.24b16d83.svg";